export default "__VITE_ASSET__CFyYiWiI__"